module.exports = __webpack_public_path__ + "img/back.5b053a51.png";